// assets/cart‑autoupdate.js
console.log('🛒 cart‑autoupdate.js loaded');

document.addEventListener('DOMContentLoaded', function() {
  const cartForm = document.querySelector('form.cart, form.cart-form');
  if (!cartForm) {
    console.warn('No cart form found.');
    return;
  }

  // whenever a qty input changes (typing, blur) or you click +/- buttons
  cartForm.querySelectorAll('input[name="updates[]"]').forEach(input => {
    // on direct input (typing)
    input.addEventListener('input', debounce(submitCart, 300));

    // on blur or change events
    input.addEventListener('change', submitCart);
    input.addEventListener('blur', submitCart);
  });

  // many themes use buttons with class .js-qty__adjust for +/- 
  cartForm.querySelectorAll('.js-qty__adjust').forEach(btn => {
    btn.addEventListener('click', () => {
      // wait a tick for the input value to update
      setTimeout(submitCart, 100);
    });
  });

  // intercept Shopify’s built‑in remove links
  cartForm.querySelectorAll('a.cart__remove, a.cart-item-remove').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      // Shopify’s remove link already points to /cart/change?line=X&quantity=0
      // just navigate there so form logic picks it up
      window.location.href = link.href;
    });
  });

  function submitCart() {
    console.log('Submitting updated cart…');
    cartForm.submit();
  }

  // simple debounce helper
  function debounce(fn, delay) {
    let timer;
    return function(...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }
});

document.addEventListener('DOMContentLoaded', function() {
  // watch for any quantity change or remove click
  document.querySelectorAll('.js-qty__adjust, .cart__remove').forEach(btn => {
    btn.addEventListener('click', updateCart);
  });

  function updateCart(event) {
    // small debounce so that if they click plus/minus quickly, we don't hammer the server
    clearTimeout(window.cartUpdateTimer);
    window.cartUpdateTimer = setTimeout(() => {
      // after the quantity/remove has been handled by Shopify, re‑fetch the cart section
      fetch('/cart?section_id=template--cart')
        .then(r => r.text())
        .then(html => {
          const parser = new DOMParser();
          const doc    = parser.parseFromString(html, 'text/html');
          // find the updated cart wrapper
          const newCart = doc.querySelector('[data-wetheme-section-type="template--cart"]');
          const oldCart = document.querySelector('[data-wetheme-section-type="template--cart"]');
          if (newCart && oldCart) oldCart.innerHTML = newCart.innerHTML;
          // re‑attach listeners to the newly injected buttons
          document.querySelectorAll('.js-qty__adjust, .cart__remove').forEach(btn => {
            btn.addEventListener('click', updateCart);
          });
        });
    }, 300);
  }
});
